import types from './actionTypes';

export const requestMenus = (ids, date) => ({
    type: types.REQUEST_MENUS,
    payload: {
        ids,
        date,
    },
});

export const setMenus = menus => ({
    type: types.SET_MENUS,
    payload: {
        menus,
    },
});
